import _ from 'lodash';
import React, { PropTypes } from 'react';
import LoadingModal from './LoadingModal';
import LoadingMessage from './LoadingMessage';
import '../../styles/ObservationTable';
import moment from 'moment';
import 'moment-timezone';
import { propertyHasChanged } from '../../../a2i/js/lib/objectComparison';

let ObservationTable = React.createClass({
	propTypes: {
		goldStandardIDs: PropTypes.array,
		handleRowClick: PropTypes.func.isRequired,
		headerHtml: PropTypes.object,
		// shouldIndicateGoldStandards defaults to true
		shouldIndicateGoldStandards: PropTypes.bool,
		// shouldDisplayGoldStandardId defaults to false
		shouldDisplayGoldStandardId: PropTypes.bool,
		isFetching: PropTypes.bool,
		items: PropTypes.array,
	},

	contextTypes: {
		router: PropTypes.object.isRequired
	},

	getInitialState: function() {
		return {
			items: [],
			filterText: '',
			listStartIndex: 0,
			resultsPerPage: 10,
			sortDirection: 'desc',
			sortParameter: 'created_at'
		};
	},

	componentDidMount: function() {
		if (this.props.items && this.props.items.length) {
			this.setState({ items: this.props.items });
		}
	},

	componentWillReceiveProps: function(newProps) {
		if (newProps.items && newProps.items.length && propertyHasChanged(this.props.items, newProps.items)) {
			this.setState({ items: newProps.items });
		}
	},

	handleFilterChange: function(event) {
		let filterText = event.target.value;
		if (!filterText.length) {
			this.resetFilterText();
		}
		this.setState({ filterText: filterText });
	},

	handleFilterKeyPress: function(event) {
		// If the user hits enter in the search box, click on the first result
		let items = this.getItemResults();

		if (event.key === 'Enter') {
			if (items && items.length) {
				this.props.handleRowClick(items[0].id);
			}
		}
	},

	getItemResults: function() {
		let { filterText, listStartIndex, resultsPerPage, sortDirection, sortParameter } = this.state,
			parametersToMatch = [
				'id',
				'created_at',
				'observation_date',
				'district_name',
				'school_name',
				'classroom_name',
				'teacher_name',
				'observer_name',
				'gold_standard_observation_id'
			],
			searchTerms = filterText.split(' ').filter((term) => term !== ''),
			items = [];

		if (!searchTerms.length) {
			items = this.props.items.asMutable();
		} else {
			items = this.props.items.filter((item) => {
				// Filter items - return true if all terms match
				let matchedTerms = 0;

				searchTerms.map((searchTerm) => {
					let textToCompare;

					parametersToMatch.every((parameter) => {
						if (item[parameter] === null || typeof(item[parameter]) === 'undefined') {
							return false;
						}

						if (parameter === 'created_at') {
							textToCompare = moment(item.created_at).tz(moment.tz.guess()).format('YYYY-MM-DD h:mm:ssa');
						} else if (parameter === 'observation_date') {
							textToCompare = moment(item.observation_date).local().format('YYYY-MM-DD');
						} else {
							textToCompare = item[parameter].toString().toLowerCase();
						}

						if (textToCompare.match(searchTerm.toLowerCase())) {
							matchedTerms++;
							return false;
						} else {
							return true;
						}
					});
				});

				return matchedTerms === searchTerms.length;
			});
		}

		let sortedItems = _.orderBy(items, sortParameter, sortDirection);

		return sortedItems.slice(listStartIndex, listStartIndex + resultsPerPage);
	},

	resetFilterText: function(event) {
		this.setState({ filterText: '' }, () => {
			this.setState({ items: this.props.items });
		});
	},

	handleResultsPerPageChange: function(event) {
		this.setState({ resultsPerPage: parseInt(event.target.value) });
	},

	calculateTotalPages: function() {
		let { items, resultsPerPage } = this.state;
		let totalResults = items.length;
		return Math.ceil(totalResults / resultsPerPage);
	},

	getCurrentPageNumber: function() {
		let { listStartIndex, resultsPerPage } = this.state;
		return Math.ceil(listStartIndex / resultsPerPage) + 1;
	},

	goToFirstPage: function() {
		this.setState({ listStartIndex: 0 });
	},

	goToLastPage: function() {
		let { listStartIndex, resultsPerPage } = this.state;
		let totalPages = this.calculateTotalPages();
		this.setState({ listStartIndex: resultsPerPage * (totalPages - 1) });
	},

	goToNextPage: function() {
		if (this.hasMorePages()) {
			let { listStartIndex, resultsPerPage } = this.state;
			this.setState({ listStartIndex: listStartIndex + resultsPerPage });
		}
	},

	goToPreviousPage: function() {
		if (this.hasPreviousPages()) {
			let { listStartIndex, resultsPerPage } = this.state;
			this.setState({ listStartIndex: listStartIndex - resultsPerPage });
		}
	},

	hasPreviousPages: function() {
		let currentPageNumber = this.getCurrentPageNumber();
		return currentPageNumber > 1;
	},

	hasMorePages: function() {
		return this.getCurrentPageNumber() < this.calculateTotalPages();
	},

	sort: function(parameter, direction) {
		this.setState({ sortParameter: parameter, sortDirection: direction });
	},

	handleHeaderCellClick: function(newParameter) {
		let { sortParameter, sortDirection } = this.state;

		if (newParameter === sortParameter) {
			// If the parameter is already selected, flip the direction
			let newDirection = sortDirection === 'asc' ? 'desc' : 'asc';
			this.setState({ sortDirection: newDirection });
		} else {
			// Otherwise, set sort direction to asc and change parameter
			this.setState({ sortParameter: newParameter, sortDirection: 'asc' });
		}
	},

	getHeaderRowCell: function(label, parameter) {
		let { sortParameter, sortDirection } = this.state;

		return (
			<th className={ 'item-' + parameter + ' header-cell' }>
				<div
					className={ 'observation-header-content ' + (sortParameter === parameter ? 'active' : '') }
					onClick={ () => this.handleHeaderCellClick(parameter) }
				>
					{ label }
				</div>
				<div className="sort-indicators">
					<i
						className={ 'glyphicon glyphicon-triangle-top' + (sortParameter === parameter && sortDirection === 'asc' ? ' active' : '') }
						onClick={ () => this.sort(parameter, 'asc') }
					/>
					<i
						className={ 'glyphicon glyphicon-triangle-bottom' + (sortParameter === parameter && sortDirection === 'desc' ? ' active' : '') }
						onClick={ () => this.sort(parameter, 'desc') }
					/>
				</div>
			</th>
		);
	},

	isGoldStandard: function(observationID) {
		if (this.props.goldStandardIDs && this.props.goldStandardIDs.includes(observationID)) {
			return true;
		} else {
			return false;
		}
	},

	render: function() {
		let { isFetching } = this.props;
		let { items, listStartIndex, resultsPerPage, sortDirection, sortParameter } = this.state;

		return(
			<div className="observation-table">
				<div className="observation-header">
					{ /*** HEADER ***/ }
					{ this.props.headerHtml ? this.props.headerHtml : '' }
					{ /*** SEARCH FILTER ***/ }
					<div className="item-filter">
						<div className="input-group">
							<input
								className="form-control item-filter"
								value={ this.state.filterText }
								onChange={ this.handleFilterChange }
								onKeyPress={ this.handleFilterKeyPress }
								placeholder="Search..."
								autoFocus={ true }
							/>
							<span className="input-group-btn">
								<button
									className="btn btn-primary reset-filter-button"
									type="button"
									onClick={ this.resetFilterText }
								>
									<i className="glyphicon glyphicon-remove" />
								</button>
							</span>
						</div>
					</div>
				</div>
				<div className="observation-table-container">
					{
						!isFetching && items.length === 0 ? (
							<div className="no-items">
								No results found.
							</div>
						) : (
							<div className="observation-table-results">
								{ /*** TABLE ***/ }
								<table className="observation-table">
									<thead>
										<tr className="observation-table-header">
											{
												this.props.shouldIndicateGoldStandards !== false ? (
													this.getHeaderRowCell('Gold', 'is_gold_standard')
												) : null
											}
											{ this.getHeaderRowCell('ID', 'id') }
											{
												this.props.shouldDisplayGoldStandardId ? (
													this.getHeaderRowCell('Gold Std', 'gold_standard_observation_id')
												) : null
											}
											{ this.getHeaderRowCell('Observer', 'observer_name') }
											{ this.getHeaderRowCell('Coding date', 'created_at') }
											{ this.getHeaderRowCell('Instruction', 'observation_date') }
											{ this.getHeaderRowCell('District', 'district_name') }
											{ this.getHeaderRowCell('School', 'district_name') }
											{ this.getHeaderRowCell('Classroom', 'district_name') }
										</tr>
									</thead>
									{ /*** RESULTS ***/ }
									<tbody>
										{ this.getItemResults().map((item) => {
											return (
												<tr
													key={ item.id }
													className={ 'item' + (this.isGoldStandard(item.id) ? ' highlight' : '') }
													onClick={ () => this.props.handleRowClick(item.id) }
												>
													{
														this.props.shouldIndicateGoldStandards !== false ? (
															<td className="is-gold-standard">
																<input
																	type="checkbox"
																	checked={ this.isGoldStandard(item.id) }
																	onChange={ () => this.props.handleRowClick(item.id) }
																	onClick={ () => this.props.handleRowClick(item.id) }
																/>
															</td>
														) : null
													}
													<td>{ item.id }</td>
													{
														this.props.shouldDisplayGoldStandardId ? (
															<td>{ item.gold_standard_observation_id }</td>
														) : null
													}
													<td>{ item.observer_name }</td>
													<td className="item-coding-date">
														{ moment(item.created_at).tz(moment.tz.guess()).format('YYYY-MM-DD h:mm:ssa') }
													</td>
													<td className="item-instruction-date">
														{ moment(item.observation_date).local().format('YYYY-MM-DD') }
													</td>
													<td>{ item.district_name ? item.district_name : '' }</td>
													<td>{ item.school_name ? item.school_name : '' }</td>
													<td>{ item.classroom_name ? item.classroom_name : '' }</td>
												</tr>
											);
										}) }
									</tbody>
								</table>
								{ /*** TABLE CONTROLS ***/ }
								<div className="observation-table-controls">
									{ /*** RESULTS PER PAGE ***/ }
									<div className="observation-table-page-size form-group">
										<label>Results per page</label>
										<select
											value={ this.state.resultsPerPage }
											onChange={ this.handleResultsPerPageChange }
											className="form-control"
										>
											<option value="10">10</option>
											<option value="25">25</option>
											<option value="50">50</option>
											<option value="100">100</option>
										</select>
									</div>
									{ /*** PAGE NAVIGATION ***/ }
									<div className="observation-table-page-count">
										<i
											className={ 'glyphicon glyphicon-step-backward' + (this.hasPreviousPages() ? '' : ' disabled') }
											onClick={ this.goToFirstPage }
										/>
										<i
											className={ 'glyphicon glyphicon-chevron-left' + (this.hasPreviousPages() ? '' : ' disabled') }
											onClick={ this.goToPreviousPage }
										/>
										<div className="observation-table-page-count-label">
											Page <span className="current-page">{this.getCurrentPageNumber()}</span> of <span className="page-count">{ this.calculateTotalPages() }</span>
										</div>
										<i
											className={ 'glyphicon glyphicon-chevron-right' + (this.hasMorePages() ? '' : ' disabled') }
											onClick={ this.goToNextPage }
										/>
										<i
											className={ 'glyphicon glyphicon-step-forward' + (this.hasMorePages() ? '' : ' disabled') }
											onClick={ this.goToLastPage }
										/>
									</div>
								</div>
							</div>
						)
					}
				</div>
				<LoadingModal
					shouldShow={ isFetching }
					message="Loading"
				/>
			</div>
		);
	}
});

module.exports = ObservationTable;



// WEBPACK FOOTER //
// ./frontend/olos/js/components/ObservationTable.jsx